import {
  CONFIRM_PRESENCE_CHANGE_INPUT,
  CONFIRM_PRESENCE_LIST,
  CONFIRM_PRESENCE_LOAD,
  CONFIRM_PRESENCE_EVENT_ID,
  CONFIRM_PRESENCE_SET,
  CONFIRM_PRESENCE_BY_CPF,
  CONFIRM_PRESENCE_ALL_PRESENT,
  CONFIRM_PRESENCE_SET_METADADOS,
} from './ConfirmarPresencaActions';

type AccountSelectedProps = {
  cpf: string;
  account: string;
  coop: string;
  agn: string;
  nuc: string;
};

export interface IProps {
  filter: {
    value: string;
    isSearchByCpf: boolean;
  };
  accountList: any;
  accountSelected: AccountSelectedProps[];
  accountLoading: boolean;
  allPresent: boolean;
  isSearchByCpf: boolean | undefined;
  eventId: any;
  metadados?: {
    latitude?: number;
    longitude?: number;
    data?: string;
    userAgent?: string;
    imagem?: any;
  };
}

export const INITIAL_STATE: IProps = {
  filter: {
    value: '',
    isSearchByCpf: true,
  },
  accountList: [],
  accountSelected: [],
  accountLoading: false,
  allPresent: false,
  isSearchByCpf: undefined,
  eventId: 0,
  metadados: undefined,
};

export default function ConfirmarPresencaReducer(
  state: IProps,
  action: { type: any; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case CONFIRM_PRESENCE_CHANGE_INPUT:
      return { ...state, filter: payload };
    case CONFIRM_PRESENCE_LIST:
      return { ...state, accountList: payload };
    case CONFIRM_PRESENCE_SET:
      return { ...state, accountSelected: payload };
    case CONFIRM_PRESENCE_EVENT_ID:
      return { ...state, eventId: payload };
    case CONFIRM_PRESENCE_BY_CPF:
      return { ...state, isSearchByCpf: payload };
    case CONFIRM_PRESENCE_SET_METADADOS:
      return { ...state, metadados: { ...state.metadados, ...payload } };
    case CONFIRM_PRESENCE_LOAD:
      return { ...state, accountLoading: payload };
    case CONFIRM_PRESENCE_ALL_PRESENT:
      return { ...state, allPresent: payload };
    default:
      return state;
  }
}
